import { render } from "./form-eer-breaches.html?vue&type=template&id=6810404e&scoped=true&ts=true&external"
import script from "./form-eer-breaches.ts?vue&type=script&lang=ts&external"
export * from "./form-eer-breaches.ts?vue&type=script&lang=ts&external"

import "./form-eer-breaches.scss?vue&type=style&index=0&id=6810404e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6810404e"]])

export default __exports__